import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 05CF7DE7-1D45-45C3-9BCC-363735A36550
 * name folder-search-outline
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-search-outline.svg
 * tags
 * - Files / Folders 
 */
export const FolderSearchOutlineIcon = createSvgIcon(<><path d="M16.5,12C19,12 21,14 21,16.5C21,17.38 20.75,18.21 20.31,18.9L23.39,22L22,23.39L18.88,20.32C18.19,20.75 17.37,21 16.5,21C14,21 12,19 12,16.5C12,14 14,12 16.5,12M16.5,14A2.5,2.5 0 0,0 14,16.5A2.5,2.5 0 0,0 16.5,19A2.5,2.5 0 0,0 19,16.5A2.5,2.5 0 0,0 16.5,14M19,8H3V18H10.17C10.34,18.72 10.63,19.39 11,20H3C1.89,20 1,19.1 1,18V6C1,4.89 1.89,4 3,4H9L11,6H19A2,2 0 0,1 21,8V11.81C20.42,11.26 19.75,10.81 19,10.5V8Z" /></>, 'FolderSearchOutlineIcon');
export default FolderSearchOutlineIcon